import "./App.css";
import { Routes, Route } from "react-router-dom";
import Login from "./components/Login";
import Register from "./components/Register";
import Home from "./components/Home";
import Dashboard from "./components/Dashboard";
import { Navbar } from "./components/Navbar";
import NotFound from "./components/NotFound";
import { AuthProvider } from "./components/auth";
import PrivateRouter from "./components/PrivateRouter";
import MyPGDetails from "./components/MyPGDetails";
import NewPG from "./components/NewPG";
import EditPG from "./components/EditPG";
import RoomDetails from "./components/RoomDetails";
import NewRoom from "./components/NewRoom";
import EditRoom from "./components/EditRoom";
import TenantDetails from "./components/TenantDetails";
import AddTenant from "./components/AddTenant";
import DeleteRoom from "./components/DeleteRoom";
import EditGuest from "./components/EditGuest";
import DeleteGuest from "./components/DeleteGuest";
import MyDashboard from "./components/MyDashboard";
import UpdatePayment from "./components/UpdatePayment";
import VacateGuest from "./components/VacateGuest";
import AddExpense from "./components/AddExpense";
import RevertPayment from "./components/RevertPayment";
import PaymentDetails from "./components/PaymentDetails";

function App() {
  return (
    <AuthProvider className="App">
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="Register" element={<Register />} />
        <Route path="Login" element={<Login />} />
        <Route
          path="MyDashboard"
          element={
            <PrivateRouter>
              <MyDashboard />
            </PrivateRouter>
          }
        >
          <Route path="PaymentDetails" element={<PaymentDetails />}>
            <Route path="UpdatePayment" element={<UpdatePayment />} />
            <Route path="RevertPayment" element={<RevertPayment />} />
          </Route>
        </Route>
        <Route
          path="Dashboard"
          element={
            <PrivateRouter>
              <Dashboard />
            </PrivateRouter>
          }
        >
          {/* <Route index element={<MyPGDetails />} /> */}
          <Route path="MyPGDetails" element={<MyPGDetails />}>
            <Route path="EditPG" element={<EditPG />} />
            <Route path="RoomDetails" element={<RoomDetails />}>
              <Route path="GuestDetails" element={<TenantDetails />}>
                <Route path="EditGuest" element={<EditGuest />} />
                <Route path="DeleteGuest" element={<DeleteGuest />} />
                <Route path="VacateGuest" element={<VacateGuest />} />
              </Route>
              <Route path="EditRoom" element={<EditRoom />} />
              <Route path="DeleteRoom" element={<DeleteRoom />} />
              <Route path="AddTenant" element={<AddTenant />} />
            </Route>
            <Route path="NewRoom" element={<NewRoom />} />
          </Route>
          <Route path="NewPG" element={<NewPG />} />
          <Route path="AddExpense" element={<AddExpense />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
